import { Component, Input } from '@angular/core';

export interface DropdownActions {
  id: string;
  icon?: {
    value: string;
    class?: string;
  };
  label: {
    value: string;
    class?: string;
  };
  hide?: boolean;
  callAction: (value: any) => void;
  showWhen?: ShowWhenDropdownActions;
  visible?: (item: any) => boolean;
  disabled?: boolean | ((item: any) => boolean);
  divider?: boolean;
}

type ShowWhenDropdownActions = {
  property: string;
  value: string | string[];
};

@Component({
  selector: 'app-dropdown-actions',
  templateUrl: './dropdown-actions.component.html',
  styleUrls: ['./dropdown-actions.component.scss'],
})
export class DropdownActionsComponent {
  @Input() actions: DropdownActions[] = [];
  @Input() item: any;
  @Input() icon: 'more-vertical' | 'more-horizontal' = 'more-horizontal';

  hideCustomActionItem(
    hide: boolean,
    showWhen: ShowWhenDropdownActions,
    item: any,
    visible?: (row: any) => boolean
  ) {
    if (hide) {
      return false;
    }
    if (visible && !visible(item)) {
      return false;
    }
    return this.validateShowWhen(showWhen, item);
  }

  isActionDisabled(action: DropdownActions, item: any): boolean {
    if (typeof action.disabled === 'function') {
      return action.disabled(item);
    }
    return !!action.disabled;
  }

  onActionClick(action: DropdownActions, item: any, event: Event): void {
    if (this.isActionDisabled(action, item)) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    action.callAction(item);
  }

  validateShowWhen(showWhen: ShowWhenDropdownActions, item: any): boolean {
    return showWhen ? this.checkShowWhen(showWhen, item) : true;
  }

  checkShowWhen(hide: ShowWhenDropdownActions, item: any) {
    const hideValue = hide.value.toString();
    const itemValue = item[hide.property].toString();

    if (Array.isArray(hide.value)) {
      return hideValue.includes(itemValue);
    }

    return itemValue === hideValue ? true : false;
  }
}
